// extracted by mini-css-extract-plugin
export var body = "_l3-0";
export var sectionHeader = "_l3-4";
export var shortcutColumns = "_l3-2";
export var shortcutList = "_l3-1";
export var shortcutSection = "_l3-3";